export const getColumns = (intl) => {
  const alert_prior = [
    intl.formatMessage({ id: 'app.alerts.priority.low' }),
    intl.formatMessage({ id: 'app.alerts.priority.medium' }),
    intl.formatMessage({ id: 'app.alerts.priority.high' }),
  ];

  const columns = [
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.dateCol' }),
      field: 'date',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        fontWeight: '900',
        fontSize: '1em',
        textAlign: 'left',
        width: '15%',
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
      renderCell: (rowData) => {
        // Formatea la fecha y la hora
        return new Date(parseInt(rowData.row.date)).toLocaleString(
          intl.locale,
          {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }
        );
      },
    },
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.descCol' }),
      field: 'description',
      cellStyle: {
        textAlign: 'left',
        fontWeight: '500',
        width: '30%',
        fontSize: '.95em',
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.levelCol' }),
      field: 'level',
      cellStyle: {
        textAlign: 'left',
        fontWeight: '500',
        width: '15%',
        fontSize: '.95em',
      },
      renderCell: (rowData) => {
        return alert_prior[parseInt(rowData.row.level) - 1] + ' ';
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      headerName: intl.formatMessage({ id: 'app.alerts.grid.locCol' }),
      field: 'location',
      cellStyle: {
        textAlign: 'left',
        fontWeight: '500',
        width: '40%',
        fontSize: '.95em',
      },
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
  ];

  return columns;
};
